import { InnerLayout } from '../style/Layout';
import React from 'react'
import ServiceCard from './ServiceCard';
import Title from './Title';
import design from '../img/design.svg';
import styled from 'styled-components'

function ServicesSection() {
    return (
            <InnerLayout>
                <ServicesSectionStyled>
                    <Title title={'Services'} span={'services'} />
                    <div className="services">
                        <ServiceCard 
                            image={design} 
                            title={'Web Design and Development'} 
                            paragraph={'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, porro.'}/>
                        {/* <div className="mid-card">
                            <ServiceCard 
                                image={design} 
                                title={'Artificial Intelligence'} 
                                paragraph={'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, porro.'}/>
                        </div>
                        <ServiceCard 
                            image={design} 
                            title={'Game Development'} 
                            paragraph={'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Esse, porro.'}/> */}
                    </div>
                </ServicesSectionStyled>
            </InnerLayout>
    )
}

const ServicesSectionStyled = styled.section`
 .services {
     margin-top: 5rem;
     display: grid;
     grid-template-columns: repeat(3, 1fr);
     grid-gap: 1.2rem;
     @media only screen and (max-width: 950px) {
        grid-template-columns: repeat(2, 1fr);
     }
     @media only screen and (max-width: 650px) {
        grid-template-columns: 1fr;
        /* margin-left: 2rem;
        margin-right: 2rem; */
     }
 }
`;

export default ServicesSection


